<template>
  <div class="page-container">
    <el-row>
      <el-col :span="4" :xs="24" class="container-left">
        <div class="container-title">
          <span>组织架构</span>
        </div>
        <div class="head-container">
          <el-tree
            :data="orgTree"
            :props="defaultProps"
            :expand-on-click-node="false"
            ref="menutree"
            node-key="id"
            :highlight-current="true"
            :default-expand-all="isShowNode"
            @node-click="handleNodeClick"
          >
            <span class="custom-tree-node tree-list" slot-scope="{ data }">
              <span>{{ data.name }}</span>
              <span class="tree-status" v-show="data.status == 0">无效</span>
            </span>
          </el-tree>
        </div>
      </el-col>
      <el-col :span="20" :xs="24" class="container-right">
        <el-row :gutter="10" class="mb8">
          <el-col :span="1.5">
            <el-button
              v-if="orgStatus == 1"
              class="add-button"
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="handleAdd"
              >新增机构</el-button
            >
            <el-checkbox
              style="padding: 0 0 15px 10px"
              v-model="isChecked"
              fill="#20b2aa"
              @change="showSonList"
              >只展示直接子集</el-checkbox
            >
          </el-col>
        </el-row>
        <el-table :data="dataList" style="width: 100%" v-loading="loading">
          <el-table-column
            prop="code"
            label="机构编码"
            min-width="120"
            align="center"
          >
            <template slot-scope="scope">
              <span
                style="cursor: pointer; color: #409eff"
                @click="rowDetail(scope.row)"
                >{{ scope.row.code }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="机构名称"
            min-width="120"
            align="center"
          >
            <template slot-scope="scope">
              <span
                style="cursor: pointer; color: #409eff"
                @click="rowDetail(scope.row)"
                >{{ scope.row.name }}</span
              >
            </template></el-table-column
          >
          <el-table-column
            prop="sort"
            label="排序号"
            min-width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="parentName"
            label="所属机构"
            min-width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态"
            align="center"
            min-width="120"
          >
            <template slot-scope="scope">
              <el-switch
                v-if="scope.row.parentId"
                v-model="scope.row.status"
                active-color="#13ce66"
                :active-value="1"
                :inactive-value="0"
                @change="statusChange(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column
            prop="updateUserName"
            label="最后操作人"
            align="center"
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            prop="updateTime"
            label="最后操作时间"
            align="center"
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            prop="age"
            label="操作"
            align="center"
            min-width="150"
            class="handle-btn"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                v-if="scope.row.parentId"
                @click="edit(scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next, sizes, total, jumper"
          :page-sizes="[10, 15, 20]"
          :page-size="pageSize"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </el-col>
    </el-row>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="700px"
      @close="handleClose"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="机构编码" prop="code">
          <el-input
            v-model="form.code"
            placeholder="输入机构编码"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="机构名称" prop="name">
          <el-input v-model="form.name" placeholder="输入机构名称"></el-input>
        </el-form-item>
        <el-form-item label="所属机构" prop="parentId">
          <el-col :span="24">
            <treeselect
              :options="orgTree"
              :value="form.parentId"
              :normalizer="normalizer"
              :show-count="true"
              :clearable="false"
              @select="orgTreeSelected"
            />
          </el-col>
        </el-form-item>
        <el-form-item label="排序号" prop="sort">
          <el-input v-model="form.sort" maxlength="5" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="机构简介" prop="introduction">
          <el-input
            type="textarea"
            v-model="form.introduction"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            v-model="form.remark"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="saveAddOrEdit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="详情"
      :visible.sync="dialogDetailVisible"
      :close-on-click-modal="false"
      width="700px"
      @close="handleDetailClose"
    >
      <el-form :model="detailForm" ref="detailForm" label-width="100px">
        <el-form-item label="机构编码" prop="code">
          <el-input
            v-model="detailForm.code"
            placeholder="请输入机构编码"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="机构名称" prop="name">
          <el-input
            v-model="detailForm.name"
            placeholder="请输入机构名称"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="所属机构"
          prop="parentId"
          v-if="detailForm.parentId"
        >
          <el-col :span="8">
            <treeselect
              :options="orgTree"
              :value="detailForm.parentId"
              :normalizer="normalizer"
              :show-count="true"
              :clearable="false"
              @select="orgTreeSelected"
              disabled
            />
          </el-col>
        </el-form-item>
        <el-form-item label="排序号" prop="sort">
          <el-input v-model="detailForm.sort" disabled></el-input>
        </el-form-item>
        <el-form-item label="机构简介" prop="introduction">
          <el-input
            type="textarea"
            v-model="detailForm.introduction"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            v-model="detailForm.remark"
            disabled
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="handle-info">
        <span>最后操作人：{{ detailForm.updateUserName }}</span
        ><span style="margin-left: 30px"
          >最后操作时间：{{ detailForm.updateTime }}</span
        >
      </div>
      <div slot="footer">
        <el-button @click="dialogDetailVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOrganizationList,
  queryOrganizationByCurrentUser,
  saveOrEditOrg,
  updateOrgStatus,
} from "@/common/api.js";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: { Treeselect },
  props: {},
  data() {
    return {
      dialogVisible: false,
      dialogDetailVisible: false,
      isShowNode: true,
      loading: false,
      rules: [],
      orgTree: [],
      dataList: [],
      orgStatus: 1,
      defaultProps: {
        children: "systemOrganizations",
        label: "name",
      },
      normalizer(node) {
        if (
          node.systemOrganizations == null ||
          node.systemOrganizations == "null"
        ) {
          delete node.systemOrganizations;
        }
        return {
          id: node.id,
          label: node.name,
          children: node.systemOrganizations,
        };
      },
      total: 0,
      pageSize: 10,
      currpage: 1,
      // 弹出层标题
      title: "",
      //表单验证
      rules: {
        code: [{ required: true, validator: this.testCode, trigger: "blur" }],
        name: [{ required: true, validator: this.testName, trigger: "blur" }],
        parentId: [{ required: true, message: "请选择机构", trigger: "blur" }],
      },
      // 所属机构id
      parentId: null,
      //新增、编辑
      form: {
        id: null,
        name: "",
        parentId: "",
        code: "",
        introduction: "",
        sort: null,
        remark: "",
      },
      detailForm: {
        id: "",
        name: "",
        parentId: "",
        code: "",
        introduction: "",
        sort: "",
        remark: "",
        updateUserName: "",
        updateTime: "",
      },
      isChecked: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    //选择器选中触发
    selectChange(e) {
      var arrNew = [];
      var dataLength = this.mineStatusValue.length;
      var eleng = e.length;
      for (let i = 0; i < dataLength; i++) {
        for (let j = 0; j < eleng; j++) {
          if (e[j] === this.mineStatusValue[i].label) {
            arrNew.push(this.mineStatusValue[i]);
          }
        }
      }
      this.$refs.tree.setCheckedNodes(arrNew); //设置勾选的值
    },
    handleNodeClick(data) {
      console.log(data);
      this.orgStatus = data.status;
      var id = data.id;
      this.parentId = id;
      this.getOrganizationList(id);
    },
    // 组织架构树
    getOrganizationTree(pid) {
      queryOrganizationByCurrentUser().then((res) => {
        console.log("res :>> ", res);
        if (res.errorCode == 200 && res.data) {
          this.orgTree = [];
          this.orgTree.push(res.data);
          console.log(this.orgTree);
          if (pid) {
            this.$nextTick(() => {
              this.$refs.menutree.setCurrentKey(pid);
            });
          } else {
            var id = res.data.id;
            this.getOrganizationList(id);
            this.parentId = id;
            this.$nextTick(() => {
              this.$refs.menutree.setCurrentKey(id);
            });
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 组织架构列表
    getOrganizationList(id) {
      this.loading = true;
      var byParent = "";
      if (this.isChecked) {
        byParent = "yse";
      } else {
        byParent = "";
      }
      var params = {
        pageSize: this.pageSize,
        pagenum: this.currpage,
        data: {
          id: id,
          byParent: byParent,
        },
      };
      getOrganizationList(params).then((res) => {
        console.log("res :>> ", res);
        this.loading = false;
        if (res.errorCode == 200) {
          this.dataList = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    showSonList() {
      this.getOrganizationList(this.parentId);
    },
    //选择所属机构
    orgTreeSelected(node) {
      this.form.parentId = node.id;
    },
    // 新增机构
    handleAdd() {
      this.reset();
      this.dialogVisible = true;
      this.title = "新增机构";
      this.form.parentId = this.parentId;
      console.log(this.form);
    },
    // 编辑机构
    edit(row) {
      console.log(row);
      this.reset();
      this.dialogVisible = true;
      this.title = "编辑机构";
      this.form = {
        id: row.id,
        name: row.name,
        parentId: row.parentId,
        code: row.code,
        introduction: row.introduction,
        sort: row.sort,
        remark: row.remark,
      };
      console.log(this.form);
    },
    // 新增或编辑保存
    saveAddOrEdit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          saveOrEditOrg(this.form).then((res) => {
            if (res.errorCode == "200") {
              this.getOrganizationList(this.parentId);
              this.getOrganizationTree(this.parentId);
              this.dialogVisible = false;
              this.$message({
                type: "success",
                message: "保存成功",
              });
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    // 详情
    rowDetail(row) {
      this.dialogDetailVisible = true;
      this.detailForm = {
        id: row.id,
        name: row.name,
        parentId: row.parentId,
        code: row.code,
        introduction: row.introduction,
        sort: row.sort,
        remark: row.remark,
        updateUserName: row.updateUserName,
        updateTime: row.updateTime,
      };
    },
    //变更状态
    statusChange(row) {
      var department = row.name;
      var mess = "";
      let text = "";
      if (row.status == 1) {
        text = "有效";
      } else if (row.status == 0) {
        text = "无效";
        mess = "设置为无效后，该机构将不在其他业务中显示";
      }
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h(
            "h3",
            null,
            '是否将 "' + department + '" 的状态变为 "' + text + '" ?',
            "警告"
          ),
          h("h4", { style: "color:#a0a0a0" }, mess),
        ]),
        showCancelButton: true,
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
            var params = {
              id: row.id,
              status: row.status,
            };
            updateOrgStatus(params).then((res) => {
              if (res.errorCode == "200") {
                this.getOrganizationTree(this.parentId);
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
              } else {
                this.$message.error(res.msg);
                if (row.status == 1) {
                  row.status = 0;
                } else if (row.status == 0) {
                  row.status = 1;
                }
              }
            });
          } else {
            done();
            if (row.status == 1) {
              row.status = 0;
            } else if (row.status == 0) {
              row.status = 1;
            }
            console.log(row.status);
          }
        },
      })
        .then((action) => {
          console.log("确定");
        })
        .catch(() => {
          console.log("取消");
        });
    },
    // 表单数据清空
    reset() {
      this.form = {
        id: null,
        name: "",
        parentId: "",
        code: "",
        introduction: "",
        sort: null,
        remark: "",
      };
    },
    //弹框关闭 重置form
    handleClose() {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    },
    handleDetailClose() {
      this.$nextTick(() => {
        this.detailForm = {
          id: "",
          name: "",
          parentId: "",
          code: "",
          introduction: "",
          sort: "",
          remark: "",
          updateUserName: "",
          updateTime: "",
        };
        this.$refs["detailForm"].resetFields();
      });
    },
    //选页
    handleCurrentChange(cpage) {
      this.currpage = cpage;
      var id = this.parentId;
      this.getOrganizationList(id);
    },
    handleSizeChange(psize) {
      this.pageSize = psize;
      var id = this.parentId;
      this.getOrganizationList(id);
    },
    isExpand() {
      this.isShowNode = !this.isShowNode;
      console.log(this.isShowNode);
    },
    testCode(rule, value, callback) {
      if (value) {
        if (value.length > 20) {
          callback(new Error("最多输入20个字符"));
        }
        var str = /^[a-z\d]*$/i;
        if (!value.match(str)) {
          callback(new Error("仅支持输入数字、字母"));
        }
        callback();
      } else {
        callback(new Error("请输入机构编码"));
      }
    },
    testName(rule, value, callback) {
      if (value) {
        if (value.length > 20) {
          callback(new Error("最多输入20个字符"));
        }
        var str =
          /[`~!@#$%^&*()_\-+=<>?:"{}|,.\ \/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/;
        if (value.match(str)) {
          callback(new Error("不能输入特殊字符"));
        }
        callback();
      } else {
        callback(new Error("请输入机构名称"));
      }
    },
  },
  created() {},
  mounted() {
    this.getOrganizationTree(this.parentId);
  },
};
</script>
<style lang="less" scoped>
.page-container {
  height: 100%;
  .el-row {
    height: 100%;
  }
  margin-left: -20px;
  .container-left {
    padding: 0 10px;
    background-color: #fff;
    height: 100%;
    width: 17%;
    .container-title {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #eee;
      .el-icon-arrow-down {
        margin-left: 15px;
        font-weight: 800;
      }
      .expand-btn {
        img {
          width: 15px;
          height: 15px;
          vertical-align: middle;
          margin-left: 5px;
          transform: rotate(0deg);
          transition: transform 0.5s;
        }
        .active {
          transform: rotate(180deg);
          transition: transform 0.5s;
        }
      }
    }
  }
  .container-right {
    padding: 12px 10px;
    border-radius: 6px;
    background-color: #fff;
    margin-top: 10px;
    margin-left: 12px;
    width: calc(83% - 12px);
    //   margin-bottom: 10px;
    //   box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    .add-button {
      margin-bottom: 10px;
      margin-right: 20px;
    }
  }
  .tree-list {
    font-size: 14px;
    .tree-status {
      font-size: 12px;
      background-color: #f0f0f0;
      padding: 2px 3px;
      color: red;
    }
  }
  .handle-info {
    text-align: right;
  }
  /deep/.el-tree-node:focus > .el-tree-node__content {
    background-color: #e4e4e4;
  }
  /deep/.el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: #e4e4e4;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/system/baseInfoManage/orgManage.vue